var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}]},[(_vm.capacityUpdatePermission)?_c('vs-row',[_c('div',{staticClass:"vx-col w-full mb-base"},[_c('CapacityForm',{attrs:{"dataCapacity":_vm.capacityItem,"isEditActive":true}})],1)]):_c('not-permission')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }